import React from "react";
import {Box, Card, CardContent} from "@mui/material";
import {useTheme} from "@mui/material/styles";

interface LogoViewProps {
    children: React.ReactNode;
}

export const LogoCardView: React.FC<LogoViewProps> = ({ children }) => {

    const theme = useTheme();

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: { xs: "flex-start", md: "center" },
                backgroundColor: theme.palette.grey[200],
                p: 2,
            }}
        >
            <Card
                elevation={5}
                sx={{
                    maxWidth: 400,
                    width: '100%',
                    p: 1,
                    boxShadow: 3,
                    borderRadius: 5
                }}
            >
                <CardContent>
                    <Box sx={{ textAlign: 'center', mb: 4, width: '100%' }}>
                        <Box
                            component="img"
                            src="logo.png"
                            alt="Logo"
                            sx={{
                                width: "250px",
                                height: "auto",
                                mb: 1,
                            }}
                        />
                    </Box>
                    {children}
                </CardContent>
            </Card>
        </Box>
    );


};